"use client";

import { AppleLogoIcon, Button } from "@ac-expo/ui-components";
import { authClient } from "@web-app/src/services/auth-client";
import { getSsoCallbackURL } from "@web-app/src/services/sso-callback";
import { useState } from "react";

type Props = {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
  redirectPath?: string | null;
  openCart?: boolean;
};

export const AppleLoginButton = ({
  onSuccess,
  onError,
  redirectPath,
  openCart,
}: Props) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleAppleLogin = async () => {
    setIsLoading(true);
    try {
      const { error } = await authClient.signIn.social({
        provider: "apple",
        callbackURL: getSsoCallbackURL(redirectPath, { openCart }),
      });
      if (error) {
        onError?.(new Error(error.message));
        return;
      }
      onSuccess?.();
    } catch (error) {
      onError?.(error instanceof Error ? error : new Error("Unexpected error"));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      type="button"
      onClick={handleAppleLogin}
      variant="outline"
      size="lg"
      className="w-full"
      disabled={isLoading}
    >
      <AppleLogoIcon className="mr-2 h-5 w-5" />
      {isLoading ? "Connexion..." : "Continuer avec Apple"}
    </Button>
  );
};
